import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { getImgEvent } from '../../../axios/Eventlog/EventLogApi';
import { StyledDataGrid } from '../../../components/StyledComponents';
import CustomPagination from '../CustomPagination';
import { Switch } from 'antd';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useLoading } from '../../../context/LoadingContext';
import ImageIcon from '@mui/icons-material/Image';
import { format, parse } from 'date-fns';
import CustomColumnsPanel from '../../../components/CustomColumnsPanel';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useAuth } from '../../../context/AuthContext';

dayjs.extend(utc);

const convertUTCToCompanyTime = (utcTime, timeZone) => {
   if (!utcTime || !timeZone) return "";

   const sign = timeZone.startsWith("-") ? -1 : 1;
   const [hh, mm] = timeZone.slice(1).split(":").map(Number);
   const offsetMinutes = sign * (hh * 60 + mm);

   return dayjs
      .utc(utcTime)
      .add(offsetMinutes, "minute");
};

const VisitorImagesGridInfoTable = ({ onRowClick, selectedDate, dispalyWeek, refreshData }) => {
   const { t } = useTranslation();
   const [dataIMG, setDataIMG] = useState([])
   const [page, setPage] = useState(0);
   const [pageSize, setPageSize] = useState(50);
   const [rowCount, setRowCount] = useState(0)
   const [show, hide] = useLoading();
   const columns = [];
   const rows = [];
   const is1440Up = window.innerWidth >= 1441;
   const { genaralSettingTimeZone } = useAuth();

   const getFromToByDateWithTZ = (date, timeZone) => {
      const base = dayjs(date).utcOffset(timeZone);

      return {
         from: base.startOf("day").utc().toISOString(),
         to: base.endOf("day").utc().toISOString(),
      };
   };

   const getUTCFromToByDate = (date) => {
      const from = new Date(Date.UTC(
         date.getFullYear(),
         date.getMonth(),
         date.getDate(),
         0, 0, 0
      )).toISOString();

      const to = new Date(Date.UTC(
         date.getFullYear(),
         date.getMonth(),
         date.getDate(),
         23, 59, 59
      )).toISOString();

      return { from, to };
   };

   function AvatarCard({ fullName, time, imageBase64, eventTypeId }) {
      const type = Number(eventTypeId);

      const isIn = type === 1;
      const isOut = type === 2;
      const localTime = dayjs.utc(time).local().format("HH:mm:ss");

      return (
         <div className="text-center w-full">
            <div className="border rounded-lg shadow p-1 h-[173px] w-full">
               <img
                  src={imageBase64}
                  alt={fullName || t('common.unidentified-user')}
                  className="w-full h-full object-cover rounded-md"
               />
            </div>
            <div className="mt-2 font-semibold text-sm text-left">
               {fullName || t('common.unidentified-user')}
            </div>
            <div className="flex items-center justify-between mt-1 text-sm text-gray-600">
               <div className="flex items-center gap-1">
                  <AccessTimeIcon style={{ width: '16px', height: '17px' }} />
                  <span>{localTime}</span>
               </div>
               {eventTypeId && (
                  <div className="flex items-center gap-1">
                     <Switch
                        checked={isIn}
                        style={{
                           backgroundColor: isIn ? '#16A34A' : '#2563EB',
                           width: '38px',
                        }}
                     />
                     <span
                        style={{
                           color: isIn ? '#16A34A' : '#2563EB',
                           fontWeight: 500,
                        }}
                     >
                        {isIn
                           ? t('common.in').toUpperCase()
                           : isOut
                              ? t('common.out').toUpperCase()
                              : ''}
                     </span>
                  </div>
               )}
            </div>
         </div>
      );
   }

   const handleRowsPerPageChange = (newPageSize) => {
      // newPageSize ở đây tuỳ CustomPagination, có thể là event hoặc number
      const size =
         typeof newPageSize === "number"
            ? newPageSize
            : parseInt(newPageSize.target.value, 10);

      setPage((prevPage) => {
         // index của record đầu tiên đang xem
         const firstRowIndex = prevPage * pageSize;

         // page mới sao cho vẫn chứa record đó
         const newPage = Math.floor(firstRowIndex / size);

         // phòng trường hợp vượt quá số trang
         const maxPage = Math.max(
            0,
            Math.ceil(rowCount / size) - 1
         );

         return Math.min(newPage, maxPage);
      });

      setPageSize(size);
   };
   return (
      <div className='w-full h-[90%]'>
         <div className='py-4 main-scroll overflow-auto component-img' style={{
            height: dispalyWeek === 6
               ? dataIMG.length > 0
                  ? is1440Up ? '900px' : '900px'
                  : is1440Up ? '900px' : '900px'
               : dispalyWeek === 5
                  ? is1440Up ? '840px' : '920px'
                  : 'auto'
         }}>
            {dataIMG?.length === 0 ? (
               <div className="flex flex-col justify-center items-center h-[90%] text-bold gap-2">
                  <ImageIcon style={{ height: "55px", width: "55px", color: "#C0C0C0" }} />
                  {t('common.no-image')}
               </div>
            ) : (
               <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
                  {dataIMG?.map((item, index) => (
                     <AvatarCard key={index} {...item} />
                  ))}
               </div>
            )}
         </div>


         <div>
            <StyledDataGrid
               sx={{
                  '.MuiDataGrid-topContainer': {
                     display: 'none',

                  },
                  '.MuiDataGrid-main': {
                     border: 'none',
                     height: 20,
                  }

               }}
               slots={{
                  pagination: CustomPagination,
                  columnsPanel: CustomColumnsPanel,
               }}
               slotProps={{
                  pagination: {
                     page,
                     count: rowCount,
                     rowsPerPage: pageSize,
                     onPageChange: setPage,
                     onRowsPerPageChange: handleRowsPerPageChange,
                  },
               }}
               rows={rows}
               columns={columns}
               disableColumnMenu
               disableSelectionOnClick
               localeText={{
                  noRowsLabel: '',
               }}
            />
         </div>
      </div>
   );
};

export default VisitorImagesGridInfoTable;
